// Home icon
export function NavHomeIcon({
  className,
  strokeWidth = 3,
}: {
  className?: string
  strokeWidth?: number
}) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      className={className}
    >
      <path
        d="M38.45 23.867V36.902C38.45 38.569 37.098 39.921 35.431 39.921H12.544C10.876 39.921 9.525 38.569 9.525 36.902V23.867"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M29.444 39.929V30.077C29.444 28.512 28.169 27.237 26.604 27.237H21.37C19.805 27.237 18.531 28.512 18.531 30.077V39.929"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M39.16 24.201C38.535 24.201 37.902 23.996 37.381 23.568L26.245 14.511C24.945 13.45 23.046 13.45 21.746 14.511L10.611 23.568C9.396 24.552 7.617 24.372 6.634 23.158C5.65 21.943 5.83 20.164 7.044 19.181L18.18 10.123C21.55 7.386 26.442 7.386 29.82 10.123L40.956 19.181C42.17 20.164 42.35 21.952 41.366 23.158C40.81 23.842 39.989 24.201 39.168 24.201H39.16Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}

// Profile/Mine icon
export function NavMineIcon({
  className,
  strokeWidth = 3,
}: {
  className?: string
  strokeWidth?: number
}) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      className={className}
    >
      <path
        d="M24 42C28.775 42 33.36 40.105 36.723 36.723C40.105 33.351 42 28.775 42 24C42 19.225 40.105 14.64 36.723 11.277C33.351 7.895 28.775 6 24 6C19.225 6 14.64 7.895 11.277 11.277C7.895 14.649 6 19.225 6 24C6 28.775 7.895 33.36 11.277 36.723C14.649 40.105 19.225 42 24 42Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M38.713 34.374C38.125 33.54 37.462 32.754 36.723 32.015C33.351 28.633 28.775 26.738 24 26.738C19.225 26.738 14.64 28.633 11.277 32.015C10.547 32.744 9.884 33.531 9.287 34.374"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M24 26.747C25.923 26.747 27.771 25.989 29.125 24.625C30.489 23.271 31.247 21.423 31.247 19.5C31.247 17.577 30.489 15.729 29.125 14.375C27.771 13.011 25.923 12.253 24 12.253C22.077 12.253 20.229 13.011 18.875 14.375C17.511 15.729 16.753 17.577 16.753 19.5C16.753 21.423 17.511 23.271 18.875 24.625C20.229 25.989 22.077 26.747 24 26.747Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}

// Palette icon for Generation
export function NavPaletteIcon({
  className,
  strokeWidth = 3,
}: {
  className?: string
  strokeWidth?: number
}) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      className={className}
    >
      <path
        d="M19.9069 12.2379C18.5241 12.252 17.4132 13.3817 17.4179 14.7645C17.4179 16.166 18.5101 17.291 19.9069 17.291C21.2522 17.291 22.396 16.1614 22.396 14.7645C22.4054 14.0989 22.1476 13.4567 21.6788 12.9785C21.2148 12.5051 20.5726 12.2379 19.9069 12.2379ZM14.1648 19.8739C12.7819 19.8879 11.671 21.0176 11.6757 22.4004C11.6757 23.802 12.7679 24.927 14.1648 24.927C15.5101 24.927 16.6538 23.7973 16.6538 22.4004C16.6632 21.7348 16.4054 21.0926 15.9366 20.6145C15.4726 20.141 14.8304 19.8739 14.1648 19.8739ZM28.13 12.2379C26.7471 12.252 25.6362 13.3817 25.6409 14.7645C25.6409 16.166 26.7331 17.291 28.13 17.291C29.4753 17.291 30.619 16.1614 30.619 14.7645C30.6284 14.0989 30.3706 13.4567 29.9018 12.9785C29.4331 12.5051 28.7956 12.2379 28.13 12.2379ZM33.9331 19.9254C32.5503 19.9395 31.4393 21.0692 31.444 22.452C31.444 23.8535 32.5362 24.9785 33.9331 24.9785C35.2784 24.9785 36.4221 23.8489 36.4221 22.452C36.4315 21.7864 36.1737 21.1442 35.705 20.666C35.2409 20.1926 34.6034 19.9254 33.9331 19.9254Z"
        fill="currentColor"
      />
      <path
        d="M6.48648 24.0086C6.48648 14.3481 14.3178 6.48645 23.9438 6.48645C33.4962 6.48645 41.3795 13.5481 41.5135 22.227C41.5135 28.0173 36.8519 32.7178 31.1222 32.7178H27.9265C27.2951 32.7178 26.7805 33.2324 26.7805 33.8637C26.7805 34.0929 26.8324 34.2789 27.1092 34.6162C27.7405 35.2475 28.1297 36.2724 28.1297 37.3319C28.1297 39.6367 26.2486 41.5135 23.9438 41.5135C14.3178 41.5135 6.48648 33.6605 6.48648 24.0086Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}

// Magic wand icon for Models
export function NavMagicWandIcon({
  className,
  strokeWidth = 3,
}: {
  className?: string
  strokeWidth?: number
}) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      className={className}
    >
      {/* Wand */}
      <path
        d="M7.089 34.893C5.637 36.345 5.637 38.711 7.089 40.173C8.541 41.635 10.907 41.625 12.369 40.173L30.229 22.313C31.681 20.861 31.681 18.495 30.229 17.033C28.777 15.571 26.412 15.581 24.949 17.033L7.089 34.893Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="21.649"
        y1="20.333"
        x2="26.929"
        y2="25.613"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Stars */}
      <path
        d="M35.306 10.169L36.494 6.97C36.606 6.656 37.053 6.656 37.164 6.97L38.352 10.169C38.393 10.27 38.464 10.341 38.565 10.382L41.764 11.57C42.079 11.682 42.079 12.128 41.764 12.24L38.565 13.428C38.464 13.469 38.393 13.54 38.352 13.641L37.164 16.84C37.053 17.154 36.606 17.154 36.494 16.84L35.306 13.641C35.266 13.54 35.194 13.469 35.093 13.428L31.895 12.24C31.58 12.128 31.58 11.682 31.895 11.57L35.093 10.382C35.194 10.341 35.266 10.27 35.306 10.169Z"
        fill="currentColor"
      />
      <path
        d="M35.306 27.511L36.494 24.313C36.606 23.998 37.053 23.998 37.164 24.313L38.352 27.511C38.393 27.613 38.464 27.684 38.565 27.725L41.764 28.912C42.079 29.024 42.079 29.471 41.764 29.583L38.565 30.771C38.464 30.811 38.393 30.882 38.352 30.984L37.164 34.182C37.053 34.497 36.606 34.497 36.494 34.182L35.306 30.984C35.266 30.882 35.194 30.811 35.093 30.771L31.895 29.583C31.58 29.471 31.58 29.024 31.895 28.912L35.093 27.725C35.194 27.684 35.266 27.613 35.306 27.511Z"
        fill="currentColor"
      />
      <path
        d="M16.166 10.169L17.354 6.97C17.466 6.656 17.913 6.656 18.025 6.97L19.213 10.169C19.253 10.27 19.324 10.341 19.426 10.382L22.624 11.57C22.939 11.682 22.939 12.128 22.624 12.24L19.426 13.428C19.324 13.469 19.253 13.54 19.213 13.641L18.025 16.84C17.913 17.154 17.466 17.154 17.354 16.84L16.166 13.641C16.126 13.54 16.055 13.469 15.953 13.428L12.755 12.24C12.44 12.128 12.44 11.682 12.755 11.57L15.953 10.382C16.055 10.341 16.126 10.27 16.166 10.169Z"
        fill="currentColor"
      />
    </svg>
  )
}

// Grid icon for Toolbox
export function NavGridIcon({
  className,
  strokeWidth = 3,
}: {
  className?: string
  strokeWidth?: number
}) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      className={className}
    >
      <rect
        x="8.30769"
        y="8.30774"
        width="13.0769"
        height="13.0769"
        rx="0.653846"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
      <rect
        x="26.6154"
        y="8.30774"
        width="13.0769"
        height="13.0769"
        rx="0.653846"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
      <rect
        x="8.30769"
        y="26.6154"
        width="13.0769"
        height="13.0769"
        rx="0.653846"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
      <rect
        x="26.6154"
        y="26.6154"
        width="13.0769"
        height="13.0769"
        rx="0.653846"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}
